export { default } from "./try-intent.tsx";
